/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

export const profileEntryLimitReached = 'profile_entry_limit_reached' as const

export type ProfileEntryLimitReached = typeof profileEntryLimitReached
